export default __webpack_public_path__ + "static/media/Chathnuka.ed3cdbbc.jpg";